/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CleanUpPolicy,
    CleanUpPolicyFromJSON,
    CleanUpPolicyFromJSONTyped,
    CleanUpPolicyToJSON,
    Partition,
    PartitionFromJSON,
    PartitionFromJSONTyped,
    PartitionToJSON,
} from './';

/**
 * 
 * @export
 * @interface Topic
 */
export interface Topic {
    /**
     * 
     * @type {string}
     * @memberof Topic
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof Topic
     */
    internal?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    partitionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    replicationFactor?: number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    replicas?: number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    inSyncReplicas?: number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    segmentSize?: number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    segmentCount?: number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    underReplicatedPartitions?: number;
    /**
     * 
     * @type {CleanUpPolicy}
     * @memberof Topic
     */
    cleanUpPolicy?: CleanUpPolicy;
    /**
     * 
     * @type {Array<Partition>}
     * @memberof Topic
     */
    partitions?: Array<Partition>;
}

export function TopicFromJSON(json: any): Topic {
    return TopicFromJSONTyped(json, false);
}

export function TopicFromJSONTyped(json: any, ignoreDiscriminator: boolean): Topic {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'internal': !exists(json, 'internal') ? undefined : json['internal'],
        'partitionCount': !exists(json, 'partitionCount') ? undefined : json['partitionCount'],
        'replicationFactor': !exists(json, 'replicationFactor') ? undefined : json['replicationFactor'],
        'replicas': !exists(json, 'replicas') ? undefined : json['replicas'],
        'inSyncReplicas': !exists(json, 'inSyncReplicas') ? undefined : json['inSyncReplicas'],
        'segmentSize': !exists(json, 'segmentSize') ? undefined : json['segmentSize'],
        'segmentCount': !exists(json, 'segmentCount') ? undefined : json['segmentCount'],
        'underReplicatedPartitions': !exists(json, 'underReplicatedPartitions') ? undefined : json['underReplicatedPartitions'],
        'cleanUpPolicy': !exists(json, 'cleanUpPolicy') ? undefined : CleanUpPolicyFromJSON(json['cleanUpPolicy']),
        'partitions': !exists(json, 'partitions') ? undefined : ((json['partitions'] as Array<any>).map(PartitionFromJSON)),
    };
}

export function TopicToJSON(value?: Topic | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'internal': value.internal,
        'partitionCount': value.partitionCount,
        'replicationFactor': value.replicationFactor,
        'replicas': value.replicas,
        'inSyncReplicas': value.inSyncReplicas,
        'segmentSize': value.segmentSize,
        'segmentCount': value.segmentCount,
        'underReplicatedPartitions': value.underReplicatedPartitions,
        'cleanUpPolicy': CleanUpPolicyToJSON(value.cleanUpPolicy),
        'partitions': value.partitions === undefined ? undefined : ((value.partitions as Array<any>).map(PartitionToJSON)),
    };
}

